import PropTypes from 'prop-types';
import SearchOverlayImpl from './search-overlay.js';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';

const { UIView } = MojitoCore.Presentation;

/**
 * View for search overlay.
 *
 * @class SearchOverlay
 * @memberof Mojito.Applications.Sports.Search
 */

/**
 * SearchOverlay prop types.
 *
 * @property {boolean} isOpen - Search open state.
 * @property {Function} [onSearchClose = ()=>{}] - Callback for search close event.
 *
 * @memberof Mojito.Applications.Sports.Search.SearchOverlay
 */
const propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onSearchClose: PropTypes.func,
};

const defaultProps = {
    onSearchClose: noop,
};

export default UIView('SearchOverlay', SearchOverlayImpl, propTypes, defaultProps);
